import { render, staticRenderFns } from "./NutritionalItemCrud.vue?vue&type=template&id=3b3a9dd3&"
import script from "./NutritionalItemCrud.vue?vue&type=script&lang=js&"
export * from "./NutritionalItemCrud.vue?vue&type=script&lang=js&"
import style0 from "./NutritionalItemCrud.vue?vue&type=style&index=0&id=3b3a9dd3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports